import { ApiResponse, PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { ROLESTABLEDATA, RoleTypeListParams, USERAGENT } from './roles.types';

type RoleType = 'admin' | 'club' | 'affiliate' | 'customer';

const getAgentViaRoleType = (client: AxiosInstance) => async (roleTypeId: string) => {
  return (
    await client.get<ApiResponse<USERAGENT[]>>('/get-agent-via-role-type', {
      params: { roleType: roleTypeId },
    })
  ).data;
};

const getRolesTableList = (roleTypeId: string) => (client: AxiosInstance) => async (params?: RoleTypeListParams) => {
  return (
    await client.get<PaginatedApiResponse<ROLESTABLEDATA[]>>(`/get-role-type`, {
      params: { roleType: roleTypeId, ...params },
    })
  ).data;
};

export const rolesQueries = {
  all: () => ['roles'] as const,

  lists: () => [...rolesQueries.all(), 'list'] as const,

  agent: (roleType: RoleType, roleTypeId: string) =>
    queryFactoryOptions({
      queryKey: [...rolesQueries.lists(), 'agent', roleType, roleTypeId] as const,
      queryFn: (client: AxiosInstance) => () => getAgentViaRoleType(client)(roleTypeId),
      enabled: Boolean(roleTypeId),
    }),

  table: (roleType: RoleType, roleTypeId: string, params?: RoleTypeListParams) =>
    queryFactoryOptions({
      queryKey: [...rolesQueries.lists(), 'table', { roleType, roleTypeId }, { params }] as const,
      queryFn: (client: AxiosInstance) => () => getRolesTableList(roleTypeId)(client)(params),
      enabled: Boolean(roleTypeId),
    }),
};
